import { Fragment } from "react";
import Correction from "../Correction";

export default function CorrectionResults(props) {
    const { question } = props;

    return (
        <>
            {question.formattedText.map((paragraph, paragraphIndex) => (
                <Fragment key={`paragraph-${paragraphIndex}`}>
                {paragraphIndex > 0 && <br />}

                {paragraph.map((block, index) => (
                    <Fragment key={index}>
                        {block.isGap ? (
                            <Correction question={question} blankId={block.id} />
                        ) : (
                            block.data
                        )}
                    </Fragment>
                ))}
                </Fragment>
            ))}
        </>
    )
}